import IApplicationState from 'app/types/state';

export function getCurrentUser(state: IApplicationState) {
  if (
    state.users.usersById !== undefined
    && state.users.currentUserId !== undefined
  ) {
    return state.users.usersById[Object.keys(state.users.usersById)[0]];
  }
  return {};
}

export function getCurrentFormUser(state: IApplicationState) {
  return {
    ...getCurrentUser(state),
    ...state.users.requestedData,
  };
}

export function getUsers(state: IApplicationState) {
  return {
    ...state.users,
    currentUser: getCurrentUser(state),
    currentFormUser: getCurrentFormUser(state),
  };
}

export function getSmartlookData(user) {
  if (user !== undefined && user.id !== undefined && user.id !== null) {
    const userData = {
      id: user.id,
      user_id: user.id,
      email: user.email,
      displayName: `${user.firstName} ${user.lastName}`,
      username: `${user.firstName} ${user.lastName}`,
      name: `${user.firstName} ${user.lastName}`,
      gitVersion: GIT_VERSION,
      organisation_id:
        user !== undefined
        && user.organisations !== undefined
        && user.organisations[0] !== undefined
          ? user.organisations[0].id
          : null,
    };
    return userData;
  }
  return undefined;
}

export function getIntercomData(user) {
  if (user !== undefined && user.id !== undefined && user.id !== null) {
    const userData = {
      id: user.id,
      email: user.email,
      name: `${user.firstName} ${user.lastName}`,
      customer_type: 'Manager',
      git_version: GIT_VERSION,
      has_bank_account: user?.bankAccount?.id !== undefined,
      payment_requests_count:
        user?.paymentRequestsCount !== undefined && user?.paymentRequestsCount > 0,
    };
    return userData;
  }
  return undefined;
}

export function getLaunchDarklyData(user) {
  if (user !== undefined && user.id !== undefined && user.id !== null) {
    const userData = {
      key: user.id,
      email: user.email,
    };
    return userData;
  }
  return undefined;
}
